export default __webpack_public_path__ + "static/media/hardware_logo.6ef540ce.jpg";